export default __webpack_public_path__ + "static/media/getx.58149efb.svg";